/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CycleSquareFlux = (props: Props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.99988 16.0001C3.34302 16.0001 1.99988 14.657 1.99988 13.0001V7.00002C1.99988 5.34317 3.34303 4.00002 4.99988 4.00002H9.49988M13.4999 4.00002H14.9999C16.6567 4.00002 17.9999 5.34317 17.9999 7.00002V13.0001C17.9999 14.657 16.6567 16.0001 14.9999 16.0001H8.49988M8.49988 16.0001L10.4999 14M8.49988 16.0001L10.4999 18M8.49988 6.00002L10.4999 4.00002L8.49988 2.00002"
      stroke={props.color ?? props?.style?.color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CycleSquareFlux;
